import { getClient } from './api';

class ApiClient {
    constructor() {
        this.client = getClient();
    }

    async get(url, conf = {}) {
        return await this.client.get(url, conf);
    }
        
    async post(url, data = {}, conf = {}) {
        return await this.client.post(url, data, conf);
    }
    
    async delete(url, conf = {}) {
        return await this.client.delete(url, conf);
    }

    async options(url, conf = {}) {
        return await this.client.options(url, conf);
    }
    
    async put(url, data = {}, conf = {}) {
        return await this.client.put(url, data, conf);
    }
}

export default ApiClient;